import HEADER_MENU, { IAppState, IUpdateItem} from '@/typings/app';
import { Module } from 'vuex';
import { IGlobalState } from '..';
import * as Types from '../action-types';
import { findUpdateContent } from '@/service/api';

const state:IAppState = {
    aliyunPath:'https://fs.iclass30.com',
    headerMenuIndex:HEADER_MENU.HOME,
    lang: sessionStorage.getItem('language') || 'zh',
    updateContent: {
        status: 0,
        content: ''
    }
};

const app: Module<IAppState, IGlobalState> = {
    namespaced: true,
    state,
    mutations: {
        [Types.SET_USER_LOGIN](state, payload: IAppState) {
            state.headerMenuIndex = payload.headerMenuIndex
        },
        [Types.SET_LANGUAGE](state, lang: string) {
            sessionStorage.setItem('language', lang)
            state.lang = lang
        },
        [Types.SET_UPDATE_CONTENT](state, payload: IUpdateItem) {
            state.updateContent.status = payload.status
            state.updateContent.content = payload.content
        }
    },
    actions: {
         // 获取上线提示信息
       async [Types.SET_UPDATE_CONTENT]({ commit }) {
        const result = await findUpdateContent();
        commit(Types.SET_UPDATE_CONTENT, result.data);
       }
    }
};
export default app;